import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import moment from 'moment'
import { Input, InputDate } from 'components/fields'
import { ElevatedButton } from 'components/layout'
import { apiAssessors, apiCodeLists, apiConfiguration, apiDashboard } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { ACTIVITY_STATES } from 'constants/enums'
import { validateEditAjPe } from 'models/adventurousJourney'
import { getAJDaysDiff } from 'helpers/dashboard'
import { asyncValidate } from '../../../../models/adventurousJourney/validateAssessor'
import Assessor from '../../../../components/forms/Assessor/Assessor'
import Supervisor from '../../../../components/forms/Supervisor/Supervisor'
import { isAssessorManagementEnabledForActivity } from '../../../../helpers/assessorHelper'

@apiDashboard.apiAdventurousJourney()
@connect(({ app, auth, api }) => ({
  userId: auth.user.personId,
  missingData: get(app, 'modal.data.missingData', false),
  dashboard: api.dashboard
}))
@apiCodeLists(['titles', 'phoneTypes'])
@apiConfiguration()
@apiAssessors()
@form({
  form: 'aj-detail-form',
  disableHook: true,
  dataKey: 'data',
  validate: validateEditAjPe,
  asyncValidate
})
class EditAJEvent extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    ajPeId: PropTypes.number,
    onEditAjEventDetail: PropTypes.func.isRequired,
    onEditAjEventAim: PropTypes.func.isRequired,
    codeLists: PropTypes.object.isRequired,
    colorClass: PropTypes.string,
    data: PropTypes.object,
    missingData: PropTypes.bool,
    userId: PropTypes.number,
    submitting: PropTypes.bool,
    onGetConfigurationValue: PropTypes.func.isRequired
  }

  async componentWillUpdate(newProps) {
    await this.handleUpdate(this.props, newProps)
  }

  getOrgId(props) {
    return get(props, 'dashboard.awards.awards.data.organization.id')
  }
  getSubCategory(props) {
    return get(props, 'values.activityCategory.id')
  }

  async handleUpdate(props, newProps) {
    const newOrgId = this.getOrgId(newProps)

    const newSubCategory = this.getSubCategory(newProps)

    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(get(newProps, 'aJDetail.ajEvent'))

    const orgIdChanged = (newOrgId !== this.getOrgId(props))

    const subCategoryChanged = (newSubCategory !== this.getSubCategory(props))

    const isAssessorManagementEnabledChanged = (isAssessorManagementEnabled !== isAssessorManagementEnabledForActivity(get(props, 'aJDetail.ajEvent')))

    if ((orgIdChanged || subCategoryChanged || isAssessorManagementEnabledChanged)
      && isAssessorManagementEnabled && newSubCategory && newSubCategory !== 'others' && newOrgId
    ) {
      newProps.onGetAvailableAssessorsForActivityCategory(newOrgId, newSubCategory)
    }
  }

  render() {
    const {
      handleSubmit,
      codeLists,
      colorClass,
      data,
      ajPeId,
      userId,
      missingData,
      submitting,
      values,
      aJDetail
    } = this.props

    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(get(aJDetail, 'ajEvent'))

    const createdByUser = userId === get(data, 'createdBy') || get(data, 'createdBy') === 0

    const disabled =
      !createdByUser ||
      (get(data, 'ajParticipantEvents[0].state.value') !==
        ACTIVITY_STATES.in_progress.id &&
        !missingData) || isAssessorManagementEnabled

    const canEditAim =
      !createdByUser ||
      get(data, 'ajParticipantEvents[0].state.value') !==
        ACTIVITY_STATES.in_progress.id ||
      get(data, 'ajParticipantEvents[0].state.value') !==
        ACTIVITY_STATES.setup.id

    const subcategoryValue = get(values, 'activityCategory.id')

    const setupAssessorId = get(values, 'setupAssessorId')

    const startDate = moment.isMoment(get(values, 'startDate'))
      ? get(values, 'startDate').clone()
      : moment(get(values, 'startDate'))

    const minEndDate =
      startDate &&
      startDate.add(getAJDaysDiff(get(data, 'awardLevel.value')), 'days')

    return (
      <form
        onSubmit={handleSubmit(fields => {
          if (disabled && canEditAim) {
            return this.props.onEditAjEventAim(fields, ajPeId)
          }
          return this.props.onEditAjEventDetail(fields, ajPeId)
        })}
      >
        <Input
          name="aim"
          label="Team Goal"
          intlKey="label.team_goal"
          disabled={disabled && !canEditAim}
        />
        <Input
          name="title"
          label="Name"
          intlKey="label.name"
          disabled={disabled}
        />
        <InputDate
          name="startDate"
          label="Start Date"
          intlKey="label.start_date"
          disabled={disabled}
        />
        <InputDate
          name="endDate"
          label="End Date"
          intlKey="label.end_date"
          disabled={disabled}
          minDay={minEndDate}
        />

        <Assessor
          colorClass={colorClass}
          titles={get(codeLists, 'titles.list')}
          subcategoryValue={subcategoryValue}
          setupAssessorId={setupAssessorId}
          formPrefix="assessor"
          sectionIntlKey="formTitle.assessor_details"
          sectionTitle="Assessor Details"
          disabled={disabled}
          isAssessorManagementEnabled={isAssessorManagementEnabled}
        />

        <Supervisor
          titles={get(codeLists, 'titles.list')}
          colorClass={colorClass}
          disabled={disabled}
        />

        {(!disabled || canEditAim) &&
          <ElevatedButton
            fullWidth
            intlKey="button.save"
            submit
            isLoading={submitting}
            disabled={disabled && !canEditAim}
          >
            Save
          </ElevatedButton>}
      </form>
    )
  }
}

export default EditAJEvent
